import { RootState } from 'store';

export const getUserState = (store: RootState) => store.user;
export const getUsername = (store: RootState) => store.user.name;
